<div *ngIf="selectedFeature.layer.metadata.hoverProperties">
  <ng-container *ngIf="selectedFeature.layer.metadata.hoverProperties.allProperties; else limitedProperties">
    <div *ngFor="let item of selectedFeature.properties | keyvalue | qmOrderBy:'key'">
      <ng-container *ngIf="
        !alwaysHiddenProperties.has(item.key) &&
        !(
          selectedFeature.layer.metadata.hoverProperties.hideProperties &&
          selectedFeature.layer.metadata.hoverProperties.hideProperties.includes(item.key)
        )
      ">
        {{item.key | qmCapitalize}}: {{item.value}}
      </ng-container>
    </div>
  </ng-container>
  <ng-template #limitedProperties>
    <div *ngFor="let key of selectedFeature.layer.metadata.hoverProperties.properties || []">
      <ng-container *ngIf="selectedFeature.properties[key] !== undefined">
        {{key | qmCapitalize}}: {{selectedFeature.properties[key]}}
      </ng-container>
    </div>
  </ng-template>
  <div *ngIf="selectedFeature.layer.metadata.hoverProperties.coordinates">
    {{'Latidude' | translate}}: {{selectedFeature.geometry.coordinates[1]}}
    <br/>
    {{'Longitude' | translate}}: {{selectedFeature.geometry.coordinates[0]}}
  </div>
</div>
